import { z } from 'zod';

// Schema for the SizePrice model
const SizePriceSchema = z.object({
  id: z.number().nullable().optional().readonly(),
  // A size's stable identity. Optional because an item saved before size guids
  // existed has none — `ensureSizePriceIdentity` mints one on its next write and
  // migration 019 backfills the rest.
  //
  // `.uuid()` was deferred with a TODO reading "reinstate once mock data or
  // server-side generation provides valid UUIDs". Both preconditions now hold:
  // `ensureSizePriceIdentity` (packages/common) is the single writer of this
  // field — including its non-crypto fallback, which also emits a valid v4 — and
  // it is applied at all three item write paths, which are the ONLY item write
  // paths (no API route and no importer writes item sizes). Audited before
  // enabling: every size guid in the database is a well-formed UUID, and none
  // predates that helper, so nothing existing can start failing validation.
  guid: z.string().uuid({ message: "Size guid must be a UUID" }).nullable().optional().readonly(),
  number: z.number().nullable().optional().readonly(),
  name: z.string().min(1, { message: "Size/price name cannot be empty" }).readonly(),
  price: z.number().default(0).readonly(),
  sku: z.string().optional(),                 // Size-specific SKU
  upc: z.string().optional(),                 // Size-specific UPC/barcode
  barcode: z.string().optional(),             // Alternative barcode format
}).strict();

export type SizePriceType = z.infer<typeof SizePriceSchema>;

export default SizePriceSchema;